import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import queryString from 'query-string';

import PartnersSection from '../PartnersSection';
import { AdminPartnerSectionEnum } from 'features/admin/partner/enums';
import {
  isAdminSelector,
  isCorporateTASelector,
} from 'redux/selectors/authenticationSelectors';
import AdminPartnersSection from 'features/admin/partner/AdminPartnersSection';
import useQueryMatch from 'hooks/useQueryMatch';
import { useAppSelector } from 'hooks/useAppSelector';
import { PartnerSectionEnum } from '../enums/PartnerSectionEnum';

const getDefaultSection = (isAdmin?: boolean) =>
  isAdmin
    ? AdminPartnerSectionEnum.withMP
    : PartnerSectionEnum.readyForPayments;

const ADMIN_PAGE_SECTIONS = Object.values(AdminPartnerSectionEnum);
const PAGE_SECTIONS = Object.values(PartnerSectionEnum);

export default function PartnersPage() {
  const isAdmin = useAppSelector(isAdminSelector);
  const isCorporateTA = useAppSelector(isCorporateTASelector);
  const navigate = useNavigate();
  const location = useLocation();
  const query = queryString.parse(location.search);
  const pageSectionMatch = useQueryMatch(
    isAdmin ? ADMIN_PAGE_SECTIONS : PAGE_SECTIONS,
  );

  useEffect(() => {
    if (!isCorporateTA && !pageSectionMatch) {
      navigate(`${location.pathname}?section=${getDefaultSection(isAdmin)}`, {
        replace: true,
      });
    }

    if (query.section && isCorporateTA) {
      navigate(location.pathname, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query.section, isAdmin, isCorporateTA, pageSectionMatch]);

  const getSection = () => {
    if (isCorporateTA) {
      return <PartnersSection />;
    }

    switch (query.section) {
      case PartnerSectionEnum.readyForPayments:
        return (
          <PartnersSection
            key={`${PartnerSectionEnum.readyForPayments}`}
            partnersType={PartnerSectionEnum.readyForPayments}
          />
        );
      case PartnerSectionEnum.pending:
        return (
          <PartnersSection
            key={`${PartnerSectionEnum.pending}`}
            partnersType={PartnerSectionEnum.pending}
          />
        );
      case AdminPartnerSectionEnum.withoutMP:
        return (
          <AdminPartnersSection
            key={`${AdminPartnerSectionEnum.withoutMP}`}
            partnersType={AdminPartnerSectionEnum.withoutMP}
          />
        );

      case AdminPartnerSectionEnum.withMP:
        return (
          <AdminPartnersSection
            key={`${AdminPartnerSectionEnum.withMP}`}
            partnersType={AdminPartnerSectionEnum.withMP}
          />
        );
    }
  };

  return <>{getSection()}</>;
}
